import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiRawFetch, apiRequest } from '../../../APIClient';
import { listIPsSelector } from '../../../reducers/listips';
import { useTrashablePromise } from '../../../hooks';
import { LIST_IPS_ACTIONS } from '../../../actions/listips';
import { sessionSelector } from '../../../reducers/session';

export const useFetchAwnIPs = () => {
  const { registerPromise } = useTrashablePromise();
  const dispatch = useDispatch();
  const hasFetched = useSelector(listIPsSelector.hasFetchedAWNIPs);
  const customerPod = useSelector(sessionSelector.getCustomerPod);

  React.useEffect(() => {
    const fetchIPs = async (pod: string) => {
      try {
        const ips = await registerPromise(apiRawFetch.getAWNIps(pod));
        dispatch(LIST_IPS_ACTIONS.SET_LIST_IPS(ips));
      } catch (e) {
        dispatch(apiRequest.setGlobalStatus(e.message, e.color || 'danger'));
      }
    };

    if (!hasFetched && customerPod) {
      fetchIPs(customerPod);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
};
